// extracted by mini-css-extract-plugin
export default {"toolBarComponent":"Toolbar_toolBarComponent__-6yhx","button":"Toolbar_button__DFHnb","is-active":"Toolbar_is-active__A-DGW","icon":"Toolbar_icon__pYP9M"};